import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=2c2439da&"
import script from "./wrapperSrc.ts?vue&type=script&lang=js&"
export * from "./wrapperSrc.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports